export const MAX_FIELD_LENGTH = 256;
export const MIN_PASSWORD_LENGTH = 12;